<nav class="w-full h-20 bg-background-dark shadow-lg flex items-center justify-center">
  <img src="assets/images/logo-{{ brand }}.svg" />
</nav>

<main class="w-full h-[calc(100vh-5rem)] bg-background p-8">
  <div class="w-full max-w-5xl m-auto">
    <div class="p-12 bg-white shadow-lg rounded-2xl w-full space-y-10">
      @if (isValidCode()) {
        <app-card-header  title="Recuperar senha" />
        <form [formGroup]="form" class="grid grid-cols-4 gap-4" (submit)="submit()">
          <div class="flex flex-col justify-start gap-1 col-span-3">
            <label for="password" class="font-semibold">Senha</label>
            <p-password
              type="password"
              inputId="password"
              formControlName="password"
              fluid
              [toggleMask]="true"
              [minlength]="8"
              [maxlength]="64"
              [feedback]="false"
              placeholder="Insira uma senha"
              [invalid]="form.get('password')?.dirty && form.get('password')?.errors"
              [disabled]="loading()"
            />
            @if (form.get('password')?.dirty && form.get('password')?.hasError('required')) {
              <p-message severity="error" variant="simple" size="small">Senha é obrigatória</p-message>
            }
          </div>
          <div class="flex w-full h-full items-end">
            <p-button class="w-full" fluid severity="secondary" (click)="generateStrongPassword()" [loading]="loading()">
              <i class="fa-solid fa-lock"></i>
              Gerar senha
            </p-button>
          </div>
          <div class="col-span-4">
            <ul class="password-rules">
              @for (validator of passwordValidators; track $index) {
                <li
                  class="text-sm"
                  [ngClass]="{
                    'text-emerald-600': validator.valid(),
                    'text-rose-600': !validator.valid()
                    }"
                >
                  @if (validator.valid()) {
                    <i class="fa-solid fa-check"></i>
                  } @else {
                    <i class="fa-solid fa-xmark"></i>
                  }
                  {{ validator.message }}
                </li>
              }
            </ul>
          </div>
          <div class="col-span-4 flex flex-col items-center justify-center gap-2 mt-8">
            <p-button class="w-72" fluid type="submit" [loading]="loading()">
              Alterar senha
            </p-button>
            @if (form.dirty && form.status === 'INVALID') {
              <p-message severity="error" variant="simple" size="small">
                Preencha uma senha válida antes de continuar.
              </p-message>
            }
          </div>
        </form>
      } @else {
        <div class="w-full h-96 flex flex-col items-center justify-center gap-8">
          <div class="text-2xl text-zinc-900 font-semibold">Este link não é mais válido, solicite um novo email de recuperação!</div>
          <p-button class="w-72" fluid (click)="goToLogin()">
            Voltar
          </p-button>
        </div>
      }
    </div>
  </div>
</main>
